<template>
    <div class="Home bg-white">
        <Navbar title="Yajobici" />
        <div class="container-fluid service overflow-hidden py-5">
            <!-- Category Start -->
            <br><br>
            <div class="container py-5">
                <div class="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
                    <div class="sub-style">
                        <h5 class="sub-title text-primary px-3">
                        Explorez ce que nous faisons de mieux
                        </h5>
                    </div>
                    <h6 class="display-6 mb-4">
                        Nos domaines d'activités
                    </h6>
                    <p class="mb-0">
                    Du bien-être à la beauté, en passant par la formation et l’événementiel, 
                    explorez nos différents domaines d’activités conçus pour vous offrir le meilleur service.</p>
                </div>
                <div v-if="loading" class="container text-center">
                    <span style="color: #F7A51B !important">
                        Affichage en cours ...
                    </span>
                </div>
                <div v-else>
                <!-- <div v-else class="container px-5"> -->
                    <div v-if="categories.length == 0" class="text-center">
                        <span class="text-danger">Désolé, il n'y a pas de domaine disponible :)</span>
                    </div>
                    <div v-else class="row g-4">
                        <div v-for="index in paginatedCategories" :key="index.id" class="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                            <CategoryCard 
                                :catTitle="index.libelle" 
                                :catDescription="index.description" 
                                :catOfferNbr="index.id" 
                                :catImage="index.photo"
                                :elId="index.id"
                            />
                        </div>
                    </div>

                    <div class="d-flex justify-content-center mt-4" v-if="totalPages > 1">
                        <nav>
                            <ul class="pagination">

                            <!-- Précédent -->
                            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                <button class="page-link" @click="changePage(currentPage - 1)">
                                Précédent
                                </button>
                            </li>

                            <!-- Pages -->
                            <li 
                                v-for="page in totalPages" 
                                :key="page"
                                class="page-item"
                                :class="{ active: currentPage === page }"
                            >
                                <button class="page-link" @click="changePage(page)">
                                {{ page }}
                                </button>
                            </li>

                            <!-- Suivant -->
                            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                <button class="page-link" @click="changePage(currentPage + 1)">
                                Suivant
                                </button>
                            </li>

                            </ul>
                        </nav>
                    </div>
                    
                </div>
            </div>
            <!-- Category End -->
        </div>
        
        <!-- Footer Start -->
            <Footer/>
        <!-- Footer End -->
    </div>  
</template>


<script> 
    import Navbar from "../../components/Navbar.vue";
    import Footer from "../../components/Footer.vue";
    import CategoryCard from "../../components/CategoryCard.vue";
    export default {
        name: 'Home',
        components: {
            Navbar,
            Footer,
            CategoryCard,
        },
        data() {
            return {
                loading: false,
                categories: [],
                currentPage: 1,
                itemsPerPage: 9
            };
        },

        computed: {
            paginatedCategories() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.categories.slice(start, end);
            },

            totalPages() {
            return Math.ceil(this.categories.length / this.itemsPerPage);
            }
        },

        mounted(){
            this.categoriesList()
        },

        methods: {
            changePage(page) {
                if (page >= 1 && page <= this.totalPages) {
                    this.currentPage = page;
                    window.scrollTo({ top: 0, behavior: "smooth" });
                }
            },

            async categoriesList() {
                this.loading = true;
                await this.$store.dispatch("staticdata/fetchCategorie")
                .then(
                    (response) => {
                        this.loading = false;
                        this.categories = response.data;
                    },
                    (error) => {
                        this.loading = false;
                        console.log("error--- ", error);
                    }
                );
            }
        }
    }
</script>

<style scoped>
.pagination .page-link {
  color: #61C7F2;
  border-radius: 8px;
  margin: 0 4px;
}

.pagination .page-item.active .page-link {
  background-color: #61C7F2;
  border-color: #61C7F2;
  color: #fff;
}

.pagination .page-link:hover {
  background-color: #F7A51B;
  color: #fff;
}
</style>